var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{class:{
        'pt-0': _vm.isAlternativeMode,
        'pt-4': !_vm.isAlternativeMode,
    },attrs:{"id":_vm.gtmTrackerId,"dense":""}},_vm._l((_vm.filterData),function(filterItem,filterName,index){return _c('v-list-item',{key:(filterName + "-" + index),staticClass:"habiteo-body-2 checkbox-item",class:{
            'pb-0': _vm.isAlternativeMode,
            'pb-4': !_vm.isAlternativeMode,
        }},[_c('TextItem',{attrs:{"filterType":_vm.filterType,"filterItem":filterItem,"filterName":filterName.toString()},on:{"filter-method":_vm.filterBy}})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fca1bce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/TextItems.vue
// module id = null
// module chunks = 